// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281236/js/" + chunkId + "." + {"44":"846aefc4","225":"45af7059","481":"1b0c30bf","486":"3d175666","770":"9ab46403"}[chunkId] + ".0.22618029333682999.chunk.js";
};